import styled from "styled-components"


 class text{
  
   DISPLAY_L = styled.div `
  /* Display L */
  
  
  font-family: Signika;
  font-style: normal;
  font-weight: bold;
  font-size: 64px;
  line-height: 72px;
  /* identical to box height, or 112% */
  
  letter-spacing: -0.02em;
  
  color: #000000;
  `
  
   DISPLAY_M = styled.div`
  /* Display M */
  
  
  font-family: Signika;
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 52px;
  /* identical to box height, or 108% */
  
  letter-spacing: -0.01em;
  
  color: #000000;
  `
  
  
   DISPLAY_S = styled.div `
  /* Display S */
  
  
  font-family: Signika;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;
  /* identical to box height, or 120% */
  
  letter-spacing: -0.01em;
  
  color: #000000;
  `
  
   HEADING_L = styled.div `
  /* Heading L */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 40px;
  /* identical to box height, or 125% */
  
  
  color: #000000;
  `
  
   HEADING_M = styled.div `
  /* Heading M */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */
  
  
  color: #000000;
  `
  
   HEADING_S = styled.div `
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  text-decoration: none !important;
  /* identical to box height, or 133% */
  
  
  color: #000000;
  `
  
   SUBHEADING_L = styled.div `
  /* Subheading L */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 32px;
  /* identical to box height, or 145% */
  
  letter-spacing: -0.02em;
  
  color: #000000;
  `
  
   SUBHEADING_M = styled.div `
  /* Subheading M */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  /* identical to box height, or 160% */
  
  letter-spacing: -0.02em;
  
  color: #000000;
  
  `
  
   SUBHEADING_S = styled.div `
  /* Subheading S */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */
  
  
  color: #000000;
  `
  
   BODY_L = styled.div `
  /* Body L */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */
  
  letter-spacing: -0.04em;
  
  color: #000000;
  `
  
   BODY_M = styled.div `
  /* Body M */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  
  
  color: #000000;
  `
  
   BODY_S = styled.div `
  /* Body S */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  
  
  color: #000000;
  `
  
   BUTTON_L = styled.div `
  /* Button L */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */
  
  letter-spacing: -0.04em;
  
  color: #000000;
  `
  
   BUTTON_M = styled.div `
  /* Button M */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  
  letter-spacing: -0.02em;
  
  color: #000000;
  `
  
   BUTTON_S = styled.div `
  /* Button S */
  
  
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  
  letter-spacing: -0.02em;
  
  color: #000000;
  `

  CAPS = styled.div`
  /* CAPS */


    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */

    text-transform: uppercase;

    color: #000000;
  `

  DETAILS = styled.div`
    /* Details */


    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 16px;
    /* identical to box height, or 123% */

    letter-spacing: -0.04em;

    color: #000000;
  `

}

export default new text();